import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=64c82ecc&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=64c82ecc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c82ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c82ecc')) {
      api.createRecord('64c82ecc', component.options)
    } else {
      api.reload('64c82ecc', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=64c82ecc&scoped=true", function () {
      api.rerender('64c82ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar/Logo.vue"
export default component.exports